import { BaseHeaderOptions, BottomNavItem, LayoutConfig, SideNavItem } from '@core/models/layout.model';

export const DEFAULT_BASE_HEADER_OPTIONS: Required<BaseHeaderOptions> = {
  title: '',
  showLogo: true,
  showNotificationsIcon: true,
  showSupportIcon: true,
  theme: 'light',
  enableBackButton: false,
};

export const DEFAULT_LAYOUT_CONFIG: LayoutConfig = {
  header: DEFAULT_BASE_HEADER_OPTIONS,
  showBottomNav: true,
};

export const BOTTOM_NAV_ITEMS: BottomNavItem[] = [
  {
    label: 'داشبورد',
    route: '/',
    iconClass: 'fa-regular fa-house',
    showBadge: false,
  },
  // {
  //   label: 'ارزها',
  //   route: '/cryptos',
  //   iconClass: '',
  //   showBadge: true,
  //   badgeContent: 'به زودی',
  // },
  // {
  //   label: 'کیف پول',
  //   route: '/wallet',
  //   iconClass: 'fa-regular fa-credit-card',
  //   showBadge: false,
  // },
  {
    label: 'پروفایل',
    route: '/profile',
    iconClass: 'fa-regular fa-user',
    showBadge: false,
  },
];

export const SIDE_NAV_ITEMS: SideNavItem[] = [
  {
    icon: 'fa-regular fa-house',
    label: 'خانه',
    route: '/',
  },
  {
    icon: 'fa-regular fa-credit-card',
    label: 'کیف پول',
    route: '/wallet',
  },
  {
    icon: 'fa-regular fa-globe',
    label: 'ارز‌ها',
    route: '/cryptos',
    disabled: true,
    trailingItem: {
      type: 'badge',
      id: 'currencies',
    },
  },
  {
    icon: 'fa-regular fa-envelopes',
    label: 'ایمیل',
    description: 'ebrahimgharajelu@gmail.com',
    route: '/email',
  },
  {
    icon: 'fa-regular fa-phone',
    label: 'شماره موبایل',
    description: '09196113175',
    route: '/phone',
  },
  {
    icon: 'fa-regular fa-building-columns',
    label: 'کارت‌های بانکی',
    route: '/bank-accounts',
  },
  {
    icon: 'fa-regular fa-mobile-screen',
    label: 'حساب‌های متصل',
    route: '/linked-accounts',
  },
  {
    icon: 'fa-regular fa-fingerprint',
    label: 'امنیت',
    route: '/security',
  },
  {
    icon: 'fa-regular fa-coins',
    label: 'نمایش ارز',
    description: 'تومان',
    route: '/defatul-currency',
  },
];
